export { default as WorkdayConfiguration } from './WorkdayConfiguration/WorkdayConfiguration';
export const WorkdayConfigurationDynamic = () => import('./WorkdayConfiguration/WorkdayConfiguration');
